<template>
  <div>
    <div class="px-3 py-2">
      <div class="d-flex">
        <div class="btn-home mb-3 ms-auto">
          <button type="button" class="btn btn-outline-main" @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>
      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100">
          <div class="card-header text-white h4 text-center" style="background: #900052">
            <strong>PRODUCTOS EN STOCK</strong>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <!--Filtro-->
              <div class="col-md-12 py-2">
                <div class="row d-flex">
                  <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">ALMACÉN</span>
                      <v-select class="text-dark flex-grow-1" label="name" :options="dataAlmacen"
                        placeholder="- Seleccionar -" v-model="selectedAlma" :reduce="(name) => name.id"
                        @input="mtdGetData">
                        <template slot="no-options">
                          No hay Almacen para la busqueda.
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">BUSCAR PRODUCTO</span>
                      <input type="text" class="form-control" placeholder="Buscar por nombre..." v-model="filterName" />
                    </div>
                  </div>
                  <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 text-md-end">
                    <span v-if="showTable" class="badge" style="background: #900052">
                      {{ filteredData.length }} producto(s) en stock
                    </span>
                  </div>
                </div>
              </div>
              <!--Fin Filtro-->

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-4" id="content-timelinetable"
                v-if="showTable && view === 'movements'">
                <div v-if="loading" class="text-center py-3">Cargando...</div>
                <div v-else-if="filteredData.length == 0" class="text-center py-3">Sin inventario</div>

                <table v-else id="tb-stock" class="table table-bordered border-main align-middle">
                  <tbody v-for="(product, productId) in filteredData" :key="'product_group_' + productId"
                    class="custom-table">
                    <tr class="text-center">
                      <th scope="col" colspan="5" style="background: #f3e2ec; color: #900052">
                        {{ product.name }} - {{ product.lote || "-" }} - {{ product.fecha_vencimiento || "-" }}
                      </th>
                      <th scope="col" style="background: #f3e2ec;">
                        <button type="button" class="btn btn-sm btn-outline-main" @click="mtdShowAudit(product)">
                          <i class="fas fa-clipboard-check"></i> Auditorías
                        </button>
                      </th>
                    </tr>
                    <tr class="text-white text-center" style="background: #900052">
                      <th scope="col">ALMACÉN</th>
                      <th scope="col">FECHA</th>
                      <th scope="col">TIPO DE MOVIMIENTO</th>
                      <th scope="col">STOCK ANTERIOR</th>
                      <th scope="col">CANTIDAD</th>
                      <th scope="col">SALDO</th>
                    </tr>
                    <tr v-for="(row, index) in product.rows" :key="'row_' + productId + '_' + index"
                      class="text-center">
                      <td>{{ row.almacen || "-" }}</td>
                      <td>{{ row.fecha || "-" }}</td>
                      <td>
                        <span :class="operationClass(row)">
                          {{ operationLabel(row) }}
                        </span>
                      </td>
                      <td>{{ row.stock_anterior }}</td>
                      <td>{{ row.quantity }}</td>
                      <td>{{ row.saldo }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-4"
                v-if="showTable && view === 'audit'">
                <Audit :almacen-id="selectedAlma" :almacen-name="selectedAlmacenName"
                  :product-detail-id="selectedProduct ? selectedProduct.product_detail_id : null"
                  :dispatch-detail-id="selectedProduct ? selectedProduct.dispatch_detail_id : null"
                  :product-name="selectedProduct ? selectedProduct.name : ''" @volver="view = 'movements'" />
              </div>

              <div v-if="!showTable" class="col-12 text-center py-4 text-muted">
                Seleccione un almacén para ver los productos en stock.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import Audit from "./Audit.vue";

export default {
  name: "productos-stock",
  components: {
    SweetAlert,
    Audit,
  },
  data() {
    return {
      swal: null,
      filterName: "",
      dataIn: [], // filas planas que vienen del back (una por movement_detail; type_movement 1,2,3)
      loading: false,
      dataAlmacen: [],
      selectedAlma: null,
      showTable: false,
      view: "movements", // 'movements' | 'audit'
      selectedProduct: null,
    };
  },
  watch: {
    selectedAlma(newVal) {
      if (newVal == null) {
        this.dataIn = [];
        this.showTable = false;
      }
      this.view = "movements";
    },
  },
  computed: {
    groupedData() {
      const groups = [];
      const map = {};
      this.dataIn.forEach((row) => {
        const name = row.name || "-";
        const lote = row.lote || "-";
        const fechaVencimiento = row.fecha_vencimiento || "-";
        const key = name + "||" + lote + "||" + fechaVencimiento;
        if (!map[key]) {
          map[key] = {
            name,
            lote: row.lote,
            fecha_vencimiento: row.fecha_vencimiento,
            product_detail_id: row.product_detail_id,
            dispatch_detail_id: row.dispatch_detail_id,
            rows: [],
          };
          groups.push(map[key]);
        }
        map[key].rows.push(row);
      });
      return groups;
    },
    filteredData() {
      if (!this.filterName || this.filterName.trim() == "") {
        return this.groupedData;
      }
      const search = this.filterName.trim().toLowerCase();
      return this.groupedData.filter(
        (product) => product.name && product.name.toLowerCase().includes(search)
      );
    },
    selectedAlmacenName() {
      const almacen = this.dataAlmacen.find((a) => a.id === this.selectedAlma);
      return almacen ? almacen.name : "";
    },
  },
  created() {
    this.vercampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    vercampus: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/Kardex/filterAlmacen/" +
          this.$store.getters.get__campus,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataAlmacen = response.data;
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    mtdGetData: function () {
      if (this.selectedAlma == null) {
        this.showTable = false;
        return;
      }
      this.loading = true;
      this.post({
        url: this.$store.getters.get__url + "/logistics/productosEnStock",
        token: this.$store.getters.get__token,
        params: {
          almacen: this.selectedAlma,
        },
      })
        .then((response) => {
          this.dataIn = response.data;
          this.showTable = true;
          if (this.dataIn.length == 0) {
            this.$refs.SweetAlert.showWarning("Sin Datos");
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    operationLabel(row) {
      const type = row.type_movement;
      switch (type) {
        case 1:
          return "ENTRADA - NOTA DE INGRESO";
        case 2:
          return "ENTRADA - ORDEN DE COMPRA";
        case 3:
          return row.es_salida_traslado
            ? "SALIDA - MOV ENTRE ALMACENES"
            : "ENTRADA - MOV ENTRE ALMACENES";
        case 4:
          return "SALIDA - VENTA DIRECTA";
        case 5:
          return "SALIDA - DESPACHOS POR RECETAS";
        case 6:
          return "ENTRADA - DEVOLUCIONES";
        case 7:
          return "AUDITORIA";
        default:
          return "MOVIMIENTO";
      }
    },
    operationClass(row) {
      const type = row.type_movement;
      if (type == 3) {
        return row.es_salida_traslado
          ? "badge text-bg-danger"
          : "badge text-bg-success";
      }
      if (type == 1 || type == 2 || type == 6) {
        return "badge text-bg-success";
      }
      if (type == 4 || type == 5) {
        return "badge text-bg-danger";
      }
      if (type == 7) {
        return "badge text-bg-info text-white";
      }
      return "badge text-bg-primary";
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
    mtdShowAudit: function (product) {
      this.selectedProduct = product;
      this.view = "audit";
    },
  },
};
</script>

<style scoped>
.custom-table th,
.custom-table td {
  font-size: 11px;
}
</style>